import React, { Component } from 'react';//eslint-disable-line
import PropTypes from 'prop-types';

export default class AbstractDriver extends Component {
  static propTypes = {
    // Function calls, when request to payment service will be sent
    payRequestSent: PropTypes.func,//eslint-disable-line
    // URL for back after the payment
    waybackUrl: PropTypes.string,//eslint-disable-line
    // Order description (usually - list of selected products)
    description: PropTypes.string,//eslint-disable-line
    // Generated order
    order: PropTypes.shape({//eslint-disable-line
      id: PropTypes.number,
      hash: PropTypes.string,
      amount: PropTypes.number,
      project: PropTypes.string
    })
  };
}

